module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAiBAMAAADfS4Y4AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUdwTP///////////////////////////////////////////////////////81e3QIAAAAOdFJOUwCB+hrlJkqXsTrBZtV6c9ZUCgAAAMtJREFUKM9jsNJ7hwYeLWZY9w4DaDEoYQo+YkDiqLx75Ack3r1DEnxkcE6ZB0gQFsSqHQFIESxgQAPsegzvLqALMgJVClBJkHUDFkGj16iCYEV1mgzcAUiCIQ+BEnoNDPdcEYLMfkBBjncBDHIqBnBBxncLGBjinjMwcEF4YEFOPTUGhj5VBoakRxMQZia9YOAEBUKfGpJFbA0MXI+AxnEkoLoz7yEWH+U5YxHkNCAvlDCj4x2DH2a8PWHYhyn4moHzoiAakJ3AgA0AAPgDEPeWUTPyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_icon_05_zh.png
// module id = IB2S
// module chunks = 34